import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const ItemsTable = ({ items, installmentInvoice }) => {
  const { presentmentCurrency } = useMarina()

  const renderItemCell = ({ label, value, isReturn, subtitles = [] }) => (
    <td
      className={classNames("py-4 pl-2 !text-sm", {
        "line-through": isReturn,
      })}
      aria-label={label}
    >
      <div className="font-semibold">{value}</div>
      {subtitles.map((subtitle, idx) => (
        <div key={idx} className="!text-xs !text-gray-600">
          {subtitle}
        </div>
      ))}
    </td>
  )

  const renderTotalCell = ({ label, value }) => (
    <td className="py-4 pr-4 text-right !text-sm" aria-label={label}>
      <div>
        {formatCurrencyFromMinorUnits({
          amount: value,
          currency: presentmentCurrency,
        })}
      </div>
    </td>
  )

  const renderRow = ({
    id,
    name,
    amount,
    originalAmount,
    isReturn,
    subtitles,
  }) => {
    return (
      <tr key={id} className="h-12" aria-label={id}>
        {renderItemCell({
          label: `item-${id}`,
          value: name,
          isReturn,
          subtitles,
        })}
        {renderTotalCell({
          label: `total-${id}`,
          value: installmentInvoice ? amount : originalAmount,
        })}
      </tr>
    )
  }

  return (
    <div className="w-full pb-4 pt-8" data-testid="invoice-items-table">
      <table className="w-full table-auto">
        <thead className="h-8 !bg-gray-200">
          <tr>
            <th className="w-5/6 pl-2">ITEM</th>
            <th className="pr-4 text-right">TOTAL</th>
          </tr>
        </thead>
        <tbody className="align-top">{items.map(renderRow)}</tbody>
      </table>
    </div>
  )
}

export const itemProps = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  subtitles: PropTypes.arrayOf(PropTypes.string),
  isReturn: PropTypes.bool.isRequired,
  originalAmount: PropTypes.number.isRequired,
}

ItemsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(itemProps)).isRequired,
  installmentInvoice: PropTypes.bool.isRequired,
}

export default ItemsTable
